<section class="user-activity-page">
  <header class="user-activity-header">
    <button mat-icon-button type="button" (click)="goBack()" matTooltip="Volver al usuario">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h1>{{ pageTitle }}</h1>
    </div>
  </header>

  <mat-card class="activity-card">
    <mat-card-content>
      <section class="user-activity-table">
        <app-table-surface
          tableId="user-activity-table"
          title="Actividad"
          titleIcon="history"
          [columns]="columns"
          [activeFilters]="activeFilterChips"
          [data]="tableData"
          [isLoading]="isLoading"
          [errorMessage]="errorMessage"
          noDataMessage="Sin actividad registrada"
          [paginationConfig]="paginationConfig"
          [showPageSizeSelector]="true"
          [pageSizeOptions]="[10, 25, 50, 100]"
          [enableFilter]="true"
          [enableColumnVisibility]="true"
          [enableDensity]="true"
          [enableRowHover]="false"
          [tableHeight]="'clamp(260px, calc(100vh - 420px), 52vh)'"
          [cellTemplate]="cellContent"
          (filterRemove)="onFilterRemove($event)"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)">
          <form filterPanel [formGroup]="filterForm" class="filters-form">
            <div class="filter-row filter-row--search">
              <div class="filter-field">
                <span class="filter-field__label">Acción</span>
                <mat-form-field appearance="fill" subscriptSizing="dynamic">
                  <mat-select aria-label="Acción" formControlName="actionType">
                    <mat-option *ngFor="let option of actionTypes" [value]="option.value">
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <app-date-range-picker
                class="date-range-field"
                label="Fecha"
                startPlaceholder="DD/MM/AAAA"
                endPlaceholder="DD/MM/AAAA"
                [formGroup]="dateRangeGroup">
              </app-date-range-picker>

            </div>
          </form>
        </app-table-surface>

        <ng-template #cellContent let-column="column" let-row="row">
          <span *ngIf="column === 'timestamp'" class="activity-date">
            {{ formatDateTime(row.timestampUtc) }}
          </span>

          <span *ngIf="column === 'actionType'" class="activity-action">
            {{ getActionLabel(row.actionType) }}
          </span>

          <span *ngIf="column === 'entity'" class="activity-entity">
            {{ row.entity || '-' }}
          </span>

          <span *ngIf="column === 'details'" class="activity-details">
            {{ row.details || '-' }}
          </span>

          <span *ngIf="column === 'result'" class="activity-result" [class.activity-result--error]="!row.isSuccessful">
            <mat-icon>{{ row.isSuccessful ? 'check_circle' : 'error' }}</mat-icon>
            {{ row.isSuccessful ? 'Correcto' : (row.errorMessage || 'Error') }}
          </span>
        </ng-template>
      </section>
    </mat-card-content>
  </mat-card>
</section>
